module.exports = __webpack_public_path__ + "static/img/best_film_editing_slider_1_4.3a40cb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best_film_editing_slider_1_4.jpg
// module id = 255
// module chunks = 0